export default "__VITE_ASSET__BZn2G1in__"